module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Heavy.373b906f.woff";